import { render, staticRenderFns } from "./MonthWiseSalesStatistics.vue?vue&type=template&id=1edb3d93&"
import script from "./MonthWiseSalesStatistics.vue?vue&type=script&lang=js&"
export * from "./MonthWiseSalesStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports